import { Box, Button, Card, Divider, TextLink, Typography } from "@drone-js/core";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import type { FunctionComponent } from "react";
import { BatchPropertyContent } from "./BatchPropertyContent";
import { useBatchCompletePageViewModel } from "./useBatchCompletePageViewModel";

export const BatchFinishIncompleteListings: FunctionComponent = () => {
    const {
        cmsData: {
            complete: {
                finishYourIncompleteListingsText,
                youHaveMoreListingsInProgressText,
                viewAllListingsText,
                completeAndPublishText,
            },
        },
    } = useStaticDataAtomValue();
    const { incompleteListings, shouldShowViewAllListingButton, viewAllListingButtonUrl } =
        useBatchCompletePageViewModel();

    if (incompleteListings === null || incompleteListings.length === 0) return null;

    return (
        <Box mb="32" data-element-name="batch-finish-incomplete-listings" data-testid="batch-incomplete-listings">
            <Card
                type="non-interactive"
                variant="outlined"
                p="24"
                data-element-name="complete-next-listing-section"
                data-testid="batch-incomplete-listings-card"
            >
                <Box mb="24">
                    <Typography variant="heading-default" textColor="base.default" data-testid="batch-incomplete-title">
                        {finishYourIncompleteListingsText}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle" mt="8" data-testid="batch-incomplete-subtitle">
                        {youHaveMoreListingsInProgressText}
                    </Typography>
                </Box>
                {incompleteListings.map((item) => (
                    <Box
                        key={`incomplete-p${item.id}`}
                        display="block"
                        justifyContent="space-between"
                        alignItems="center"
                        mb="24"
                        qM={{ display: "flex" }}
                        data-testid={`batch-incomplete-listing-${item.id}`}
                    >
                        <BatchPropertyContent {...item} />
                        <Box
                            flexShrink={0}
                            mt="16"
                            mb="24"
                            ms="0"
                            width="100%"
                            qM={{ mt: "0", mb: "0", ms: "16", width: "auto" }}
                        >
                            <Button
                                variant="label"
                                size="l"
                                hierarchy="primary"
                                label={completeAndPublishText}
                                width="parent-fit"
                                data-element-name="complete-publish"
                                data-property-id={item.id}
                                data-testid={`batch-incomplete-complete-button-${item.id}`}
                                onClick={() => {
                                    window.location.href = item.onboardingUrl;
                                }}
                            />
                        </Box>
                        <Box display="block" qM={{ display: "none" }}>
                            <Divider direction="horizontal" />
                        </Box>
                    </Box>
                ))}
                {shouldShowViewAllListingButton && viewAllListingButtonUrl && (
                    <Box display="flex" justifyContent="center" qM={{ justifyContent: "start" }}>
                        <TextLink
                            label={viewAllListingsText}
                            textVariant="body-s-strong"
                            data-element-name="view-all-listings"
                            data-testid="batch-view-all-listings-link"
                            href={viewAllListingButtonUrl}
                        />
                    </Box>
                )}
            </Card>
        </Box>
    );
};
